import { useState } from 'react';

import { useLingui } from '@lingui/react/macro';

import { useLocale } from '../../../../hooks/useLocale';
import { LOAN_DURATION_OPTIONS_DE } from '../../../GetStarted/GetStartedDE/loanOptions';
import { OptionCards, TOption } from '../../OptionCards/OptionCards';
import { StepLayout } from '../../StepLayout/StepLayout';

type TDuration = (typeof LOAN_DURATION_OPTIONS_DE)[number]['value'];

const DURATION_ICONS: Record<TDuration, string> = {
  few_months: '⏱️',
  one_to_two_years: '📅',
  three_plus_years: '🗓️',
  ongoing: '🔄',
};

// DIT-709. Card picker — selecting a card advances (no CTA). Nav lands in 0.6;
// local state for now, swaps to the shared RHF form store (DIT-664) once merged.
export const DurationScreen = () => {
  const { t } = useLingui();
  const { i18n } = useLocale();
  const [duration, setDuration] = useState<TDuration>();

  const options: TOption<TDuration>[] = LOAN_DURATION_OPTIONS_DE.map(
    (option) => ({
      value: option.value,
      icon: DURATION_ICONS[option.value],
      label: i18n._(option.label),
    }),
  );

  return (
    <StepLayout
      stageTitle={t`Credit request`}
      heading={t`How long do you need the loan for?`}
      hideCta
    >
      <OptionCards
        name="duration"
        options={options}
        value={duration}
        onChange={(value) => {
          setDuration(value);
          // TODO(0.6): advance to the next screen via useMobileSignupNav.
        }}
      />
    </StepLayout>
  );
};
